<div class="threshold-group-view-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <button
      (click)="modify()"
      [disabled]="!(userPermissions | async).settlement.write"
      mat-stroked-button color="primary"
    ><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100">
    <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <h3>Konfiguracje</h3>

      <ng-container *ngFor="let group of thresholdDictionary.groups; let i = index">
        <div fxFlex="100" fxLayout="column" fxLayoutGap="15px" class="threshold-record-container mat-elevation-z2">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="25px" class="list-counter">
              <div>{{i+1}}.</div>
            </div>

            <app-detail fxFlex header="Ryzyko ASF" [value]="group.internalRisk?.name"></app-detail>

            <app-detail fxFlex header="Grupa ryzyk" [value]="group.groupName"></app-detail>

            <app-detail fxFlex header="Kod ryzyka">
              <mat-chip-list>
                <mat-chip
                  class="green-mat-chip" selected
                  *ngFor="let riskCode of group.riskCodes"
                >{{riskCode}}</mat-chip>
              </mat-chip-list>
            </app-detail>

          </div>
        </div>
      </ng-container>

    </mat-card>
  </div>

</div>
